<template>
    <div
        id="team-page"
        class="page-content"
        :class="$mq"
        data-aos="fade-in"
        data-aos-duration="700"
        data-aos-easing="ease-in-out"
        data-aos-once="true"
    >
        <base-text type="h3" class="heading">{{ data.heading }}</base-text>
        <team-section heading="Directors" :members="getTeam('directors')" />
        <team-section heading="Tech Team" :members="getTeam('tech')" />
        <team-section
            heading="Marketing Team"
            :members="getTeam('marketing')"
        />
        <team-section heading="Events Team" :members="getTeam('events')" />
    </div>
</template>

<script>
    // CMS DATA LOADING
    import dataLoader from '../mixins/dataLoader';
    import data from '../content/pages/team.md';

    import TeamSection from '../components/TeamSection';

    export default {
        name: 'team',

        mixins: [dataLoader(data)],

        components: {
            TeamSection,
        },

        methods: {
            getTeam(team) {
                return this.data.members.filter(member =>
                    member.team.includes(team)
                );
            },
        },
    };
</script>

<style lang="scss" scoped>
    #team-page {
        margin: 150px 0;

        &.tablet,
        &.mobile {
            margin: 100px 0;
        }

        .heading {
            margin-bottom: $standard-space;
        }

        &.mobile {
            .heading {
                margin-bottom: $standard-space-mobile;
            }
        }
    }
</style>
